import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';

import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { AuthguardService, NoAuthGuard } from '@fitness-force/shared';
import { LogoutComponent } from './logout/logout.component';
import { GoogleLoginProvider, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { IonicModule } from '@ionic/angular';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthCallbackComponent } from './callback/auth-callback.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
},

// {
//   path: 'login', loadChildren: () => import('./login/login.component').then(c => c.LoginComponentModule), data: { isTenant: false, breadcrumb: "ANALYTICS" }
// },
  {
    path: 'login',
    canActivate: [NoAuthGuard],
    component: LoginComponent,
    data: {
      title:"Login"
    },
    

},

// {
//   path: 'forgot-password', loadChildren: () => import('./forgotpassword/forgotpassword.component').then(c => c.ForgotpasswordComponentModule), data: { isTenant: false, breadcrumb: "ANALYTICS" }
// },
  {
    path: 'forgot-password',
    canActivate: [NoAuthGuard],
    component: ForgotpasswordComponent,
    data: {
      title:"Forgot Password"
    },
  },
  // {
  //   path: 'logout', loadChildren: () => import('./logout/logout.component').then(c => c.LogoutComponent), data: { isTenant: false, breadcrumb: "ANALYTICS" }
  // },
  {
    path: 'logout',
    // canActivate: [AuthguardService],
    component: LogoutComponent
  },
  {
    path: 'callback',
    component: AuthCallbackComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    SocialLoginModule,
    // CarouselModule.forRoot(),
    IonicModule,
    CommonModule,
    FormsModule

  ],
  providers: [
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              environment.GOOGLE_AUTH_ID
            )
          }
        ],
        onError: (err: any) => {
          console.error(err);
        }
      } as SocialAuthServiceConfig,

    },
  ],
})
export class AuthModule {}
